export default "__VITE_ASSET__d8b3df4d__"